import React from "react";
import useCurrencySymbol from "./CurrencySymbol";
import { formatDateTime } from "./CommonFunctions";

const DetailRow = ({ 
  label, 
  value, 
  condition = true,
  pl = "5", 
  width = "150px",
  showBold,
  showValueAtRight,
  type,
  dontShowAtRightSide
}) => {
  const currencySymbol = useCurrencySymbol();
  
  if (!condition) return null;

  // Generate dynamic width class
  const widthClass = `w-[${width}]`;
  // Generate dynamic padding class
  const paddingClass = `pl-${pl}`;

const renderValue = () => {
  if (value === null || value === undefined || value === "") {
    if (type === "number" || type === "currency") return "0";
    return "-";
  }

  if (typeof value === "boolean") return value ? "Yes" : "No";

  // ✅ HTML rendering
  if (type === "html" && typeof value === "string") {
    return (
      <div
        className="max-w-full overflow-x-auto"
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }

  if (React.isValidElement(value)) return value;

  if (typeof value === "object" && !Array.isArray(value)) {
    if (value.label && value.value) return value.label;
    return JSON.stringify(value);
  }

  return value;
};

// const formatDateFromTimestamp=(value)=> {
//   if (!value) return "";

//   // If value looks like seconds (10 digits), convert to ms
//   const timestamp = value.toString().length === 10 ? value * 1000 : value;

//   return new Date(timestamp).toISOString().split("T")[0];
// }
  return (
    <tr className="align-top">
      <td 
        className={`py-[6px] ${widthClass} ${showBold ? "text-[#000000] font-semibold" : "text-[--list-item-gray]"}`}
      >
        {label}
      </td>
      <td 
        className={`py-[6px] ${paddingClass} text-[#000000] ${showBold ? "font-semibold" : ""} ${((showValueAtRight || type === "currency" || type === "number") && !dontShowAtRightSide) ? "text-right" : ""}`}
      >
        {type === "currency" ? `${currencySymbol}${renderValue()}` : type=="date" ? formatDateTime(renderValue()) : renderValue()}
      </td>
    </tr>
  );
};

export default DetailRow;